import { StyleSheet } from "react-native";
import { fonts } from "../../../styles/theme";

const PropertyDetailsStyle = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#F8F8F8",
    padding: 20,
  },
  header: {
    fontSize: 20,
    fontWeight: '600',
    //marginBottom: 20,
    fontFamily: fonts.regular,
  },
  headerContainer: {
    display: "flex",
    flexDirection: "row",
    gap: 7,
  },
  detailsContainer: {
    backgroundColor: "#FFF",
    borderRadius: 10,
    padding: 10,
    marginBottom: 20,
  },
  details: {
    width: "100%",
    flexDirection: "row",
    display: "flex",
    justifyContent: "space-between",
    borderBottomWidth: 1,
    borderBottomColor: "#EEE",
    padding: 10,
  },
  title: {
    fontSize: 16,
    color: "#979797",
    marginTop: 10,
    fontFamily: fonts.regular,
  },
  value: {
    fontSize: 16,
    fontWeight: "bold",
    marginTop: 10,
    color: "#3629B7",
    textAlign: "right",
    fontFamily: fonts.regular,
  },
  link: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#3629B7",
    textDecorationLine: "underline",
    marginTop: 10,
    fontFamily: fonts.regular,
  },
});

export default PropertyDetailsStyle;